import { memo } from 'react';

import Label from '@/ui/components/Form/Label';

import type { Props } from './types';

const CheckboxFilterGroup = ({ idPrefix, options, register }: Props) => (
  <fieldset>
    {options.map(({ label, name, value }) => {
      const id = `${idPrefix}-${value ?? name}`;

      return (
        <Label key={id} htmlFor={id} reverse text={label}>
          <input
            {...register(name)}
            className="align-middle mr-1"
            id={id}
            type="checkbox"
            value={value}
          />
        </Label>
      );
    })}
  </fieldset>
);

export default memo(CheckboxFilterGroup);
